import { useEffect, useState } from "react";

interface State<T> {
	data: T | null;
	loading: boolean;
	error: string | null;
}

/**
 * Тонкая обёртка над запросом с отменой устаревшего ответа.
 *
 * Раздел обновляется по таймеру и по смене фильтров, поэтому ответы легко
 * приходят не в том порядке, в каком уходили запросы; флаг отмены гарантирует,
 * что на экран попадёт результат последнего запроса, а не последнего ответа.
 */
export default function useRequest<T>(
	request: () => Promise<T>,
	dependencies: unknown[],
): State<T> {
	const [state, setState] = useState<State<T>>({
		data: null,
		loading: true,
		error: null,
	});

	useEffect(() => {
		let cancelled = false;

		setState((previous) => ({ ...previous, loading: true, error: null }));

		request()
			.then((data) => {
				if (cancelled) return;
				setState({ data, loading: false, error: null });
			})
			.catch((error) => {
				if (cancelled) return;
				setState({
					data: null,
					loading: false,
					error: error?.message ?? "Request failed",
				});
			});

		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, dependencies);

	return state;
}
